
export default {
  name: 'AtomContentSlider',
  props: {}
}
